const transparentCls = "_n29tvach9y";
const transparentLabelCls = "_n29t16yqa22";

export { transparentCls, transparentLabelCls };
import "./Transparent.style.linaria.module.css";
//# sourceMappingURL=Transparent.style.js.map
